 import React from 'react';
import withRouter from '../../Components/Common/withRouter';
import LandingNavbar from '../Landing/ForecastNestHome/navbar';
import LandingFooter from '../Landing/ForecastNestHome/footer';

/**
 * The shell every sign-in screen renders inside.
 *
 * It had no header at all, which left the one page a stranger is most likely to
 * arrive on with no way back to the site, and a footer saying only who built
 * it -- so Terms, Privacy and the Refund Policy were unreachable from the page
 * where someone is deciding whether to hand over an account. Both now come from
 * the same components the rest of the site uses.
 *
 * The landing footer is bg-dark, which is what this page's background already
 * is, so it sits in the design rather than fighting it.
 */
const ParticlesAuth = ({ children }) => {
    return (
        <React.Fragment>
            <LandingNavbar />
            {/* Clear of the fixed navbar. The wrapper's own pt-5 is 48px, which
                is shorter than the bar, so the card slid underneath it. */}
            {/* No banner behind the card.
                The template put a dark navy panel across the top of every auth
                screen. It never belonged to this site — everything else is
                light, with dark blue and green as accents — and it broke the
                header outright: the navbar is built for a light background, so
                its brand mark renders in text-primary and simply vanished
                against the navy.

                Removing it fixes both at once, and is the reason there is no
                light/dark mode for the navbar to switch between: one background
                everywhere means one navbar everywhere. */}
            <div className="auth-page-wrapper pt-5 mt-5">
                {children}
            </div>

            <LandingFooter />
        </React.Fragment>
    );
};

export default withRouter(ParticlesAuth);